import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import CallBackBlockData from '../../../Models/Content/CallBackBlockData';
import CallBackForm from './CallBackForm';

export default class CallBackBlock extends EpiComponent<CallBackBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <CallBackForm context={this.getContext()} contentData={this.props.data} />;
  }
}
